// Ocean Insight Pro Mobile - Redux Store Configuration
// Centralized state management using Redux Toolkit

import { configureStore } from '@reduxjs/toolkit';
import weatherSlice from './weatherSlice';
import oceanographicSlice from './oceanographicSlice';
import fishingSlice from './fishingSlice';
import tripsSlice from './tripsSlice';
import userSlice from './userSlice';
import appSlice from './appSlice';
import mapSlice from './mapSlice';
import privateWaypointsSlice from './privateWaypointsSlice';
import buoySlice from './buoySlice';

// Configure the store with all slices
export const store = configureStore({
  reducer: {
    weather: weatherSlice,
    oceanographic: oceanographicSlice,
    fishing: fishingSlice,
    trips: tripsSlice,
    user: userSlice,
    app: appSlice,
    map: mapSlice,
    privateWaypoints: privateWaypointsSlice,
    buoy: buoySlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Increase warning threshold to reduce console warnings
        warnAfter: 128,
      },
      immutableCheck: {
        // Increase immutable check threshold
        warnAfter: 128,
      },
    }),
});

// Define RootState and AppDispatch types for TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export the store as default
export default store;
